import React from "react";
import BrandTable from "./components/Table/BrandTable";
const Brands = () => {
    return <BrandTable />;
};

export default Brands;
